const surahsOfQuran = [
  `Fatiha Suresi`,
  `Bakara Suresi`,
  `Âl-i İmran Suresi`,
  `Nisâ Suresi`,
  `Mâide Suresi`,
  `En'âm Suresi`,
  `A'râf Suresi`,
  `Enfâl Suresi`,
  `Tevbe Suresi`,
  `Yunus Suresi`,
  `Hûd Suresi`,
  `Yusuf Suresi`,
  `Ra'd Suresi`,
  `İbrahim Suresi`,
  `Hicr Suresi`,
  `Nahl Suresi`,
  `İsrâ Suresi`,
  `Kehf Suresi`,
  `Meryem Suresi`,
  `Tâ-Hâ Suresi`,
  `Enbiyâ Suresi`,
  `Hac Suresi`,
  `Mü'minûn Suresi`,
  `Nûr Suresi`,
  `Furkan Suresi`,
  `Şuarâ Suresi`,
  `Neml Suresi`,
  `Kasas Suresi`,
  `Ankebût Suresi`,
  `Rûm Suresi`,
  `Lokman Suresi`,
  `Secde Suresi`,
  `Ahzâb Suresi`,
  `Sebe' Suresi`,
  `Fâtır Suresi`,
  `Yâsin Suresi`,
  `Sâffât Suresi`,
  `Sâd Suresi`,
  `Zümer Suresi`,
  `Mü'min Suresi`,
  `Fussilet Suresi`,
  `Şûrâ Suresi`,
  `Zuhruf Suresi`,
  `Duhân Suresi`,
  `Câsiye Suresi`,
  `Ahkaf Suresi`,
  `Muhammed Suresi`,
  `Fetih Suresi`,
  `Hucurât Suresi`,
  `Kaf Suresi`,
  `Zâriyât Suresi`,
  `Tûr Suresi`,
  `Necm Suresi`,
  `Kamer Suresi`,
  `Rahmân Suresi`,
  `Vâkıa Suresi`,
  `Hadid Suresi`,
  `Mücâdele Suresi`,
  `Haşr Suresi`,
  `Mümtehine Suresi`,
  `Saf Suresi`,
  `Cum'a Suresi`,
  `Münâfikûn Suresi`,
  `Teğabün Suresi`,
  `Talâk Suresi`,
  `Tahrim Suresi`,
  `Mülk Suresi`,
  `Kalem Suresi`,
  `Hâkka Suresi`,
  `Meâric Suresi`,
  `Nuh Suresi`,
  `Cin Suresi`,
  `Müzzemmil Suresi`,
  `Müddessir Suresi`,
  `Kıyamet Suresi`,
  `İnsan Suresi`,
  `Mürselât Suresi`,
  `Nebe' Suresi`,
  `Nâziât Suresi`,
  `Abese Suresi`,
  `Tekvir Suresi`,
  `İnfitâr Suresi`,
  `Mutaffifin Suresi`,
  `İnşikak Suresi`,
  `Bürûc Suresi`,
  `Târık Suresi`,
  `A'lâ Suresi`,
  `Gâşiye Suresi`,
  `Fecr Suresi`,
  `Beled Suresi`,
  `Şems Suresi`,
  `Leyl Suresi`,
  `Duhâ Suresi`,
  `İnşirâh Suresi`,
  `Tin Suresi`,
  `Alak Suresi`,
  `Kadir Suresi`,
  `Beyyine Suresi`,
  `Zilzâl Suresi`,
  `Adiyât Suresi`,
  `Kâria Suresi`,
  `Tekasür Suresi`,
  `Asr Suresi`,
  `Hümeze Suresi`,
  `Fil Suresi`,
  `Kureyş Suresi`,
  `Mâûn Suresi`,
  `Kevser Suresi`,
  `Kâfirûn Suresi`,
  `Nasr Suresi`,
  `Tebbet Suresi`,
  `İhlas Suresi`,
  `Felâk Suresi`,
  `Nâs Suresi`,
]

export default surahsOfQuran
